import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { LanguageService } from './../../business-services/language.service';
import { SecureStorage } from '../../../../../Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Features } from '../../business-entities/step.class';
import * as CommonEnums from '../../../../../Autofacets-Core/src/app/utils/enums';
@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html'
})
export class HeaderComponent implements OnInit {
  // For the IP based Language option need to set this flag to true
  isLanguageIpBased: boolean = false;
  ipAddress: any;
  languages: any[];
  currentLang: string;
  selectedLanguageFlag: string;
  selectedLanguageText: string;
  logoUrlLink: string;
  selectedLangExpireDate = new Date();
  isLanguageDropDown: boolean = false;
  features: Features[] = [];
  EnableCookieConsent: boolean = false;
  constructor(
    private readonly languageService: LanguageService,
    private readonly cookieservice: CookieService,
    private readonly translate: TranslateService,
    private readonly globalSetting: GlobalSetting,
    private readonly currentLanguageService: CurrentLanguage,
    private readonly secureStorage: SecureStorage,
  ) { }

  ngOnInit(): void {
    this.logoUrlLink = this.globalSetting.getGlobalLogoUrlLink();
    this.currentLang = EnvSetting.LANGUAGE_CONFIG.defaultLanguage;
    this.selectedLanguageText = EnvSetting.LANGUAGE_CONFIG.defaultLanguageText;
    this.selectedLanguageFlag = EnvSetting.LANGUAGE_CONFIG.defaultLanguageFlag;
    this.selectedLangExpireDate.setDate(this.selectedLangExpireDate.getDate() + 1);
    if (EnvSetting.language.LanguageOverRule) {
      this.currentLang = EnvSetting.language.LanguageOverRuleDefault
      this.cookieservice.set('userSelectedLanguage', this.currentLang, this.selectedLangExpireDate, '/', '', false, "Strict");
      this.currentLanguageService.currentLanguage.next(this.currentLang);
      this.translate.use(this.currentLang);
    }
    else {
      this.getAllLanguage();
    }
    if (this.secureStorage.getKeyData('feature')) {
      this.features = this.secureStorage.getKeyData('feature');
      if (this.features?.length > 0) {
        this.EnableCookieConsent = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.EnableCookieConsent)?.isActive
      }
    }
    this.currentLanguageService.featureList.subscribe((response) => {
      if (response?.length > 0) {
        this.EnableCookieConsent = response?.find(x => x.featureCode === CommonEnums.FeatureCode.EnableCookieConsent)?.isActive;
        if (this.EnableCookieConsent) {
          let node = document.createElement('script');
          node.src = EnvSetting.Widget_CookieScript_Key;
          node.type = 'text/javascript';
          document.getElementsByTagName('head')[0].appendChild(node);
        }
      }
    })
  }

  getAllLanguage() {
    this.isLanguageDropDown = true;
    this.languageService.getAllLanguage().then((response) => {
      this.cookieservice.delete('userSelectedLanguage');
      this.languages = response.filter(x => x.key != 'de-DE' && x.key != 'fr-FR');
      if (this.languages && this.languages.length > 1) {
        this.currentLang = this.cookieservice.get('userSelectedLanguage').length > 0 ? this.cookieservice.get('userSelectedLanguage') : this.currentLang;
        this.selectedLanguageText = this.languages.find(search => search.key === this.currentLang).value;
        this.selectedLanguageFlag = this.getFlagImage(this.languages.find(search => search.key === this.currentLang).flagName);
      } else {
        this.currentLang = response[0].key;
        this.selectedLanguageText = response[0].value;
        this.selectedLanguageFlag = this.getFlagImage(response[0].flagName);
      }
      this.cookieservice.set('userSelectedLanguage', this.currentLang, this.selectedLangExpireDate, '/', '', false, "Strict");
      this.translate.use(this.currentLang);
      this.currentLanguageService.currentLanguage.next(this.currentLang);
    });
  }
  getFlagImage(flag: string) {
    let uri = "assets/images/countryflags/"
    if (flag != undefined)
      return uri + flag;
  }
  onlogoClick() {
    this.globalSetting.bookingWidget.next(true);
  }

  ChangeLanguage(languageCode: string) {

    if (this.languages.find(s => s.key === languageCode)) {
      this.currentLang = languageCode;
      this.selectedLanguageText = this.languages.find(s => s.key === this.currentLang).value;
      this.selectedLanguageFlag = this.getFlagImage(this.languages.find(s => s.key === this.currentLang).flagName);
    }
    else {
      this.currentLang = EnvSetting.LANGUAGE_CONFIG.defaultLanguage;
      this.selectedLanguageText = EnvSetting.LANGUAGE_CONFIG.defaultLanguageText;
      this.selectedLanguageFlag = EnvSetting.LANGUAGE_CONFIG.defaultLanguageFlag;
    }
    this.cookieservice.delete('userSelectedLanguage');
    this.cookieservice.set('userSelectedLanguage', this.currentLang, this.selectedLangExpireDate, '/', '', false, "Strict");
    this.translate.use(this.currentLang);
    this.currentLanguageService.currentLanguage.next(this.currentLang);
  }

}
